/* eslint-disable func-names, max-len, no-new, no-underscore-dangle */
if ($('.home-sign-up').length > 0) {
  $('.signup-arrow').click(function () {
    $('.sign-up-drop-down').slideToggle();

    $(this).closest('.home-sign-up').toggleClass('open-sign-up');
    return false;
  });
}
